import { useEffect } from "react";
export default function VisibilitySensor({ children, onChange, ref }) {
  useEffect(() => {
    if (!ref) return;
    //console.log("#EFFECT VIEWABILITY");
    const observer = new IntersectionObserver(([entry]) =>
      onChange?.(entry.isIntersecting)
    );

    observer.observe(ref);

    return () => observer.disconnect();
  }, [ref, onChange]);

  return <>{children}</>;
}
